import React from 'react'
import style from './Geopin.less'

const Geopin = ({className}) => {
  return <div className={style.geopin}></div>
}

export default Geopin


// WEBPACK FOOTER //
// ./src/components/Geopin.jsx